export default __webpack_public_path__ + "static/media/109.8800d165.png";